module.exports = __webpack_public_path__ + "img/about.fae25e77.jpg";